import {Button} from '../index';
import {ContentCardEntity} from '~/types/CollectionEntity';
import SanityImage from '../media/SanityImage.client';

export function ProductListContentCard({
  contentCard,
}: {
  contentCard: ContentCardEntity;
}) {
  return (
    <div className="relative h-full col-span-2 md:col-span-1">
      {contentCard?.image != null && (
        <SanityImage
          className={'rounded-[10px] md:rounded-none w-full h-full'}
          objectFit="cover"
          crop={contentCard.image?.crop}
          hotspot={contentCard.image?.hotspot}
          layout="fill"
          src={contentCard.image.asset?._ref}
          breakpoints={[[355, 488]]}
        />
      )}

      <div className="absolute left-10 right-10 bottom-[60px] flex flex-col items-start">
        <span className="font-header text-28/28 font-extrabold">
          {contentCard.title}
        </span>

        {contentCard?.button?.buttonText != null && (
          <Button
            to={contentCard.button.buttonHref ?? '#'}
            key={contentCard.button.buttonText}
            variant={contentCard.button.buttonType}
            width={contentCard.button.buttonWidth}
            className="mt-5"
          >
            {contentCard.button.buttonText}
          </Button>
        )}
      </div>
    </div>
  );
}
